import { useEffect, useState, useRef } from "react";
import { Autocomplete, IconButton, TextField, Tooltip, Checkbox, Skeleton, CircularProgress } from "@mui/material";
import { today } from "../../../../Js/Date";
import { useSelector } from "react-redux";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import PrintIcon from '@mui/icons-material/Print';
import SearchIcon from '@mui/icons-material/Search';
import { categoryListAPICall } from "../Configuration/Category/CategoryAPI";
import { vieWareHouseLocationAPICall } from "../Configuration/wareHouseLocationAPI";
import { inventoryAdjustmentReportAPICall } from '../../../../API/Report/stockAdjustmentReportAPI';
import "../../../../css/Report/TrailBalanace.css"
import { IaReportExcel } from "./IaReportExcel";
import { getIAreportList } from "./ReportSlice";
import store from "../../../../Redux/store";
import ReactToPrint from '../../../Shared/print/ReactToPrint';

const IaReport = () => {

  const userRole = useSelector((state) => state.userRoleSlice.value)
  const allowedBranchList = useSelector((state) => state.allAllowedBranchesSlice.value);
  const allBranchesList = useSelector((state) => state.allBranchesSlice.value);
  const userInfo = useSelector((state) => state.loginResponseSlice.value);
  const userBranchId = userInfo?.branchPk;
  const CategoryList = useSelector((state) => state.categorySlice.value);
  const wareHouseLocationList = useSelector((state) => state.wareHouseLocationSlice.value);
  const iaReportList = useSelector((state) => state.ReportSlice.IAreport);
  const { tableLoading } = useSelector((state) => state.mainDashBoardSlice)
  const decimalPosition = Number(localStorage.getItem("decimalPosition") || 2);
  const userDefaultBranch = {
    _id: userInfo?.branchPk,
    branchName: userInfo?.branchName
  }

  const formValuesInitial = {
    branch: userRole === "user" ? userDefaultBranch : null,
    fromDate: today,
    toDate: today,
    location: null,
    selectedCategories: null,
    isRawMaterial: false,
  }
  const [formValues, setFormValues] = useState(formValuesInitial)
  const [validationAlert, setValidationAlert] = useState({})

  const handleInputChange = (key) => (e) => {
    if (e.target.type === 'checkbox') {
      setFormValues({ ...formValues, [key]: e.target.checked });
    } else {
      setFormValues({ ...formValues, [key]: e.target.value });
    }
  };
  const handleCategoryChange = (value, key) => {
    if (key === 'selectedCategories') {
      setFormValues((prev) => ({
        ...prev,
        [key]: Array.isArray(value) ? value : [value]
      }));
    } else {
      setFormValues((prev) => ({ ...prev, [key]: value }));
    }

    if (validationAlert[key]) {
      setValidationAlert({ ...validationAlert, [key]: "" });
    }
  };
  const getBranchLocForm = (key) => (e, newValue) => {

    if (key === "branch") {
      setFormValues({
        ...formValues,
        branch: newValue,
        location: null,
      });
    }
    if (key === "location") {
      setFormValues({ ...formValues, location: newValue });
    }
    if (validationAlert[key]) {
      setValidationAlert({ ...validationAlert, [key]: "" });
    }

  };


  const formatFilterInfo = (filters) => {
    const parts = [];

    if (filters?.fromDate && filters?.toDate) {
      parts.push(`As of ${filters?.fromDate} to ${filters?.toDate}`);
    }

    if (filters?.branchList) {
      parts.push(`Branch: ${filters?.branchList?.storeCode}-${filters?.branchList?.branchName}`);
    }
    if (filters?.location) {
      parts.push(`Branch: ${filters?.location?.name}`);
    }


    return parts; // Return the array directly
  };

  const [isLoading, setIsLoading] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [grandTotals, setGrandTotals] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const printRef = useRef();

  // Helper function to safely format numbers
  const formatNumber = (value) => {
    const num = Number(value);
    return isNaN(num) ? '0.00' : num.toFixed(decimalPosition);
  };

  const saveBtnClick = async () => {
    if (!formValues.branch || !formValues.location || !formValues.fromDate || !formValues.toDate) {
      setValidationAlert({
        branch: !formValues.branch ? "Branch is required!" : "",
        location: !formValues.location ? "Location is required!" : "",
        fromDate: !formValues.fromDate ? "From Date is required!" : "",
        toDate: !formValues.toDate ? "To Date is required!" : ""
      });
      return;
    }

    const body = {
      branchId: formValues?.branch?._id || userBranchId,
      locationId: formValues?.location?._id || null,
      fromDate: new Date(formValues.fromDate).getTime(),
      toDate: new Date(formValues.toDate).getTime(),
    };

    console.log('📊 Fetching IA Report:', body);
    const result = await inventoryAdjustmentReportAPICall(body, setIsLoading);
    
    if (result?.success) {
      // Filter by selected categories if any
      let filteredData = result.data || [];
      const hasFilter = formValues.selectedCategories && formValues.selectedCategories.length > 0;
      
      if (hasFilter) {
        const selectedCategoryNames = formValues.selectedCategories.map(cat => cat.categoryName);
        filteredData = filteredData.filter(group => 
          selectedCategoryNames.includes(group.itemGroup)
        );
        console.log(`🔍 Filtered to ${filteredData.length} categories:`, selectedCategoryNames);
      }
      
      setReportData(filteredData);
      
      // Recalculate grand totals ONLY if categories are filtered
      if (hasFilter && filteredData.length > 0) {
        const recalculatedTotals = {
          totalStockInQty: filteredData.reduce((sum, g) => sum + (g.groupTotals?.totalStockInQty || 0), 0),
          totalStockInValue: filteredData.reduce((sum, g) => sum + (g.groupTotals?.totalStockInValue || 0), 0),
          totalWastageQty: filteredData.reduce((sum, g) => sum + (g.groupTotals?.totalWastageQty || 0), 0),
          totalWastageValue: filteredData.reduce((sum, g) => sum + (g.groupTotals?.totalWastageValue || 0), 0),
          totalOutQty: filteredData.reduce((sum, g) => sum + (g.groupTotals?.totalOutQty || 0), 0),
          idealConsQty: filteredData.reduce((sum, g) => sum + (g.groupTotals?.idealConsQty || 0), 0),
          idealConsValue: filteredData.reduce((sum, g) => sum + (g.groupTotals?.idealConsValue || 0), 0),
          bookClosingQty: filteredData.reduce((sum, g) => sum + (g.groupTotals?.bookClosingQty || 0), 0),
          bookClosingValue: filteredData.reduce((sum, g) => sum + (g.groupTotals?.bookClosingValue || 0), 0),
          physicalClosingQty: filteredData.reduce((sum, g) => sum + (g.groupTotals?.physicalClosingQty || 0), 0),
          actConsQty: filteredData.reduce((sum, g) => sum + (g.groupTotals?.actConsQty || 0), 0),
          actConsValue: filteredData.reduce((sum, g) => sum + (g.groupTotals?.actConsValue || 0), 0),
          varianceQty: filteredData.reduce((sum, g) => sum + (g.groupTotals?.varianceQty || 0), 0),
          varianceValue: filteredData.reduce((sum, g) => sum + (g.groupTotals?.varianceValue || 0), 0)
        };
        setGrandTotals(recalculatedTotals);
      } else {
        // Use backend grand totals when no filter is applied
        setGrandTotals(result.grandTotals || {});
      }
      // Also store in Redux for Excel export
      store.dispatch(getIAreportList({ rsList: [{ list: result.flatData || [] }] }));
      console.log('✅ IA Report loaded:', result.data?.length, 'groups');
    } else {
      console.error('❌ IA Report failed');
      setReportData([]);
      setGrandTotals({});
    }
  };

  const downloadExcel = IaReportExcel({
    reportData,
    grandTotals,
    decimalPosition: localStorage.getItem("decimalPosition"),
    formValues
  });

  useEffect(() => {
    // Only call if we have a valid branch ID
    const branchId = formValues?.branch?._id || userBranchId;
    if (branchId && branchId !== 'noBranch') {
      categoryListAPICall({ isPos: true, branchId });
    }
  }, [formValues?.branch, userBranchId])


  useEffect(() => {
    if (formValues?.branch !== null) {
      vieWareHouseLocationAPICall({
        branchId: formValues?.branch?._id,
      });
    }
  }, [formValues?.branch]);

  // 🚀 Ultra-Fast Print Function for IA Report (Auto-Orientation)
  const handleFastPrint = async () => {
    // Check if data is available
    if (!reportData || reportData.length === 0) {
      console.error('No IA report data available to print');
      return;
    }

    try {
      console.log('🚀 Starting IA Report Fast Print - Auto-orientation mode');

      // Show orientation selection dialog
      const useLandscape = window.confirm(
        'This report has 28 columns and works best in Landscape orientation.\n\n' +
        'Click OK for Landscape (recommended)\n' +
        'Click Cancel for Portrait (may be cramped)'
      );

      // Create IA Report HTML content based on orientation
      const createIAReportHTML = (isLandscape) => {
        const filterInfo = formatFilterInfo(formValues);
        
        // Adjust font sizes and padding based on orientation
        const fontSize = isLandscape ? 9 : 7;
        const headerFontSize = isLandscape ? 8 : 6;
        const padding = isLandscape ? '4px 6px' : '2px 3px';
        const itemNameWidth = isLandscape ? '10%' : '8%';
        
        // Build table rows
        const tableRows = reportData.map((group, groupIndex) => {
          let itemCounter = 0;
          
          const groupItems = group.items?.filter(item => {
            if (!searchTerm) return true;
            const search = searchTerm.toLowerCase();
            return (
              item.itemName?.toLowerCase().includes(search) ||
              item.itemNo?.toLowerCase().includes(search) ||
              item.uom?.toLowerCase().includes(search)
            );
          }).map((item, itemIndex) => {
            itemCounter++;
            return `
              <tr style="cursor: pointer;">
                <td style="text-align: left; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd;">${itemCounter}</td>
                <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd;">${item.itemNo || ''}</td>
                <td style="text-align: left; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; max-width: 100px; word-wrap: break-word;">${item.itemName || ''}</td>
                <td style="text-align: center; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd;">${item.uom || ''}</td>
                <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd;">${Number(item.conversion || 0).toFixed(decimalPosition)}</td>
                <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd;">${Number(item.rate || 0).toFixed(decimalPosition)}</td>
                <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd;">${Number(item.openingStock || 0).toFixed(decimalPosition)}</td>
                <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; color: green;">${Number(item.purchase || 0).toFixed(decimalPosition)}</td>
                <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; color: green;">${Number(item.transferIn || 0).toFixed(decimalPosition)}</td>
                <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; color: green;">${Number(item.totalStockInQty || 0).toFixed(decimalPosition)}</td>
                <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; color: green;">${Number(item.totalStockInValue || 0).toFixed(decimalPosition)}</td>
                <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; color: red;">${Number(item.purchaseReturn || 0).toFixed(decimalPosition)}</td>
                <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; color: red;">${Number(item.transferOut || 0).toFixed(decimalPosition)}</td>
                <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; color: red;">${Number(item.rawWastageQty || 0).toFixed(decimalPosition)}</td>
                <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; color: red;">${Number(item.sfWastage || 0).toFixed(decimalPosition)}</td>
                <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; color: red;">${Number(item.finishedWastageQty || 0).toFixed(decimalPosition)}</td>
                <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; color: red;">${Number(item.totalWastageQty || 0).toFixed(decimalPosition)}</td>
                <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; color: red;">${Number(item.totalWastageValue || 0).toFixed(decimalPosition)}</td>
                <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; color: red;">${Number(item.totalOutQty || 0).toFixed(decimalPosition)}</td>
                <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd;">${Number(item.idealConsQty || 0).toFixed(decimalPosition)}</td>
                <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd;">${Number(item.idealConsValue || 0).toFixed(decimalPosition)}</td>
                <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd;">${Number(item.bookClosingQty || 0).toFixed(decimalPosition)}</td>
                <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd;">${Number(item.bookClosingValue || 0).toFixed(decimalPosition)}</td>
                <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd;">${Number(item.physicalClosingQty || 0).toFixed(decimalPosition)}</td>
                <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd;">${Number(item.actConsQty || 0).toFixed(decimalPosition)}</td>
                <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd;">${Number(item.actConsValue || 0).toFixed(decimalPosition)}</td>
                <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd;">${Number(item.varianceQty || 0).toFixed(decimalPosition)}</td>
                <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd;">${Number(item.varianceValue || 0).toFixed(decimalPosition)}</td>
              </tr>
            `;
          }).join('');

          // Group header
          const groupHeader = `
            <tr style="background-color: #E6F4EA; color: #1B5E20; font-weight: 600; border-top: 1px solid #CFE8D5; border-bottom: 1px solid #CFE8D5;">
              <td colspan="28" style="text-align: left; padding: ${padding}; font-size: ${fontSize + 1}px; font-weight: bold; border: 1px solid #ddd;">
                ${group.itemGroup}
              </td>
            </tr>
          `;

          // Group totals
          const groupTotals = `
            <tr style="background-color: #BDD7EE; font-weight: bold;">
              <td colspan="9" style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; font-weight: bold;">${group.itemGroup} Total</td>
              <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; color: green; font-weight: bold;">${Number(group.groupTotals?.totalStockInQty || 0).toFixed(decimalPosition)}</td>
              <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; color: green; font-weight: bold;">${Number(group.groupTotals?.totalStockInValue || 0).toFixed(decimalPosition)}</td>
              <td colspan="5" style="border: 1px solid #ddd;"></td>
              <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; color: red; font-weight: bold;">${Number(group.groupTotals?.totalWastageQty || 0).toFixed(decimalPosition)}</td>
              <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; color: red; font-weight: bold;">${Number(group.groupTotals?.totalWastageValue || 0).toFixed(decimalPosition)}</td>
              <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; color: red; font-weight: bold;">${Number(group.groupTotals?.totalOutQty || 0).toFixed(decimalPosition)}</td>
              <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; font-weight: bold;">${Number(group.groupTotals?.idealConsQty || 0).toFixed(decimalPosition)}</td>
              <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; font-weight: bold;">${Number(group.groupTotals?.idealConsValue || 0).toFixed(decimalPosition)}</td>
              <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; font-weight: bold;">${Number(group.groupTotals?.bookClosingQty || 0).toFixed(decimalPosition)}</td>
              <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; font-weight: bold;">${Number(group.groupTotals?.bookClosingValue || 0).toFixed(decimalPosition)}</td>
              <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; font-weight: bold;">${Number(group.groupTotals?.physicalClosingQty || 0).toFixed(decimalPosition)}</td>
              <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; font-weight: bold;">${Number(group.groupTotals?.actConsQty || 0).toFixed(decimalPosition)}</td>
              <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; font-weight: bold;">${Number(group.groupTotals?.actConsValue || 0).toFixed(decimalPosition)}</td>
              <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; font-weight: bold;">${Number(group.groupTotals?.varianceQty || 0).toFixed(decimalPosition)}</td>
              <td style="text-align: right; padding: ${padding}; font-size: ${fontSize}px; border: 1px solid #ddd; font-weight: bold;">${Number(group.groupTotals?.varianceValue || 0).toFixed(decimalPosition)}</td>
            </tr>
          `;

          return groupHeader + groupItems + groupTotals;
        }).join('');

        // Grand totals row
        const grandTotalsRow = `
          <tr style="background-color: #5B9BD5; color: white; font-weight: bold;">
            <td colspan="9" style="text-align: right; padding: ${padding}; font-size: ${fontSize + 1}px; font-weight: bold; border: 1px solid #ddd;">GRAND TOTAL</td>
            <td style="text-align: right; padding: ${padding}; font-size: ${fontSize + 1}px; font-weight: bold; border: 1px solid #ddd;">${Number(grandTotals.totalStockInQty || 0).toFixed(decimalPosition)}</td>
            <td style="text-align: right; padding: ${padding}; font-size: ${fontSize + 1}px; font-weight: bold; border: 1px solid #ddd;">${Number(grandTotals.totalStockInValue || 0).toFixed(decimalPosition)}</td>
            <td colspan="5" style="border: 1px solid #ddd;"></td>
            <td style="text-align: right; padding: ${padding}; font-size: ${fontSize + 1}px; font-weight: bold; border: 1px solid #ddd;">${Number(grandTotals.totalWastageQty || 0).toFixed(decimalPosition)}</td>
            <td style="text-align: right; padding: ${padding}; font-size: ${fontSize + 1}px; font-weight: bold; border: 1px solid #ddd;">${Number(grandTotals.totalWastageValue || 0).toFixed(decimalPosition)}</td>
            <td style="text-align: right; padding: ${padding}; font-size: ${fontSize + 1}px; font-weight: bold; border: 1px solid #ddd;">${Number(grandTotals.totalOutQty || 0).toFixed(decimalPosition)}</td>
            <td style="text-align: right; padding: ${padding}; font-size: ${fontSize + 1}px; font-weight: bold; border: 1px solid #ddd;">${Number(grandTotals.idealConsQty || 0).toFixed(decimalPosition)}</td>
            <td style="text-align: right; padding: ${padding}; font-size: ${fontSize + 1}px; font-weight: bold; border: 1px solid #ddd;">${Number(grandTotals.idealConsValue || 0).toFixed(decimalPosition)}</td>
            <td style="text-align: right; padding: ${padding}; font-size: ${fontSize + 1}px; font-weight: bold; border: 1px solid #ddd;">${Number(grandTotals.bookClosingQty || 0).toFixed(decimalPosition)}</td>
            <td style="text-align: right; padding: ${padding}; font-size: ${fontSize + 1}px; font-weight: bold; border: 1px solid #ddd;">${Number(grandTotals.bookClosingValue || 0).toFixed(decimalPosition)}</td>
            <td style="text-align: right; padding: ${padding}; font-size: ${fontSize + 1}px; font-weight: bold; border: 1px solid #ddd;">${Number(grandTotals.physicalClosingQty || 0).toFixed(decimalPosition)}</td>
            <td style="text-align: right; padding: ${padding}; font-size: ${fontSize + 1}px; font-weight: bold; border: 1px solid #ddd;">${Number(grandTotals.actConsQty || 0).toFixed(decimalPosition)}</td>
            <td style="text-align: right; padding: ${padding}; font-size: ${fontSize + 1}px; font-weight: bold; border: 1px solid #ddd;">${Number(grandTotals.actConsValue || 0).toFixed(decimalPosition)}</td>
            <td style="text-align: right; padding: ${padding}; font-size: ${fontSize + 1}px; font-weight: bold; border: 1px solid #ddd;">${Number(grandTotals.varianceQty || 0).toFixed(decimalPosition)}</td>
            <td style="text-align: right; padding: ${padding}; font-size: ${fontSize + 1}px; font-weight: bold; border: 1px solid #ddd;">${Number(grandTotals.varianceValue || 0).toFixed(decimalPosition)}</td>
          </tr>
        `;

        // Column widths adjustment based on orientation
        const columnWidths = isLandscape 
          ? ['3%', '6%', '10%', '4%', '5%', '5%', '6%', '5%', '5%', '5%', '5%', '5%', '5%', '5%', '5%', '5%', '5%', '5%', '5%', '5%', '5%', '5%', '5%', '5%', '5%', '5%', '5%', '5%']
          : ['2%', '4%', '8%', '3%', '3%', '3%', '4%', '3%', '3%', '3%', '3%', '3%', '3%', '3%', '3%', '3%', '3%', '3%', '3%', '3%', '3%', '3%', '3%', '3%', '3%', '3%', '3%', '3%'];

        return `
          <div style="font-family: Arial, sans-serif; padding: ${isLandscape ? '10px' : '5px'}; font-size: ${fontSize}px;">
            <!-- Header -->
            <div style="text-align: center; margin-bottom: ${isLandscape ? '15px' : '10px'};">
              <h1 style="margin: 0; font-size: ${isLandscape ? '16px' : '12px'}; color: #333;">INVENTORY ADJUSTMENT REPORT</h1>
              <p style="margin: 5px 0; font-size: ${isLandscape ? '10px' : '8px'}; color: #666;">
                ${isLandscape ? '(Landscape)' : '(Portrait)'} - ${filterInfo.join(' | ')}
              </p>
            </div>

            <!-- Table -->
            <table style="width: 100%; border-collapse: collapse; font-size: ${headerFontSize}px; table-layout: fixed;">
              <thead>
                <tr style="background-color: #5B9BD5; color: white; font-weight: bold;">
                  <th style="padding: ${padding}; text-align: left; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[0]};">NO</th>
                  <th style="padding: ${padding}; text-align: left; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[1]};">Code</th>
                  <th style="padding: ${padding}; text-align: left; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[2]};">Item Name</th>
                  <th style="padding: ${padding}; text-align: center; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[3]};">Uom</th>
                  <th style="padding: ${padding}; text-align: right; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[4]};">Conv</th>
                  <th style="padding: ${padding}; text-align: right; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[5]};">Rate</th>
                  <th style="padding: ${padding}; text-align: right; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[6]};">Open</th>
                  <th style="padding: ${padding}; text-align: right; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[7]};">Pur</th>
                  <th style="padding: ${padding}; text-align: right; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[8]};">In</th>
                  <th style="padding: ${padding}; text-align: right; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[9]};">Stk Qty</th>
                  <th style="padding: ${padding}; text-align: right; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[10]};">Stk Val</th>
                  <th style="padding: ${padding}; text-align: right; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[11]};">Ret</th>
                  <th style="padding: ${padding}; text-align: right; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[12]};">Out</th>
                  <th style="padding: ${padding}; text-align: right; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[13]};">Raw</th>
                  <th style="padding: ${padding}; text-align: right; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[14]};">SF</th>
                  <th style="padding: ${padding}; text-align: right; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[15]};">Fin</th>
                  <th style="padding: ${padding}; text-align: right; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[16]};">Wst Qty</th>
                  <th style="padding: ${padding}; text-align: right; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[17]};">Wst Val</th>
                  <th style="padding: ${padding}; text-align: right; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[18]};">Tot Out</th>
                  <th style="padding: ${padding}; text-align: right; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[19]};">Idl Qty</th>
                  <th style="padding: ${padding}; text-align: right; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[20]};">Idl Val</th>
                  <th style="padding: ${padding}; text-align: right; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[21]};">Bk Qty</th>
                  <th style="padding: ${padding}; text-align: right; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[22]};">Bk Val</th>
                  <th style="padding: ${padding}; text-align: right; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[23]};">Phy Qty</th>
                  <th style="padding: ${padding}; text-align: right; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[24]};">Act Qty</th>
                  <th style="padding: ${padding}; text-align: right; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[25]};">Act Val</th>
                  <th style="padding: ${padding}; text-align: right; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[26]};">Var Qty</th>
                  <th style="padding: ${padding}; text-align: right; border: 1px solid #ddd; font-size: ${headerFontSize}px; width: ${columnWidths[27]};">Var Val</th>
                </tr>
              </thead>
              <tbody>
                ${tableRows}
                ${grandTotalsRow}
              </tbody>
            </table>
            
            <!-- Print Instructions -->
            <div style="margin-top: 20px; padding: 10px; border: 1px solid #ddd; background-color: #f9f9f9;">
              <p style="margin: 0; font-size: 10px; color: #666;">
                <strong>Print Instructions:</strong> 
                ${isLandscape 
                  ? 'Set printer to "Landscape" orientation in print dialog for best results.' 
                  : 'Portrait mode selected. Consider Landscape for better readability.'}
              </p>
            </div>
          </div>
        `;
      };

      const iaReportHTML = createIAReportHTML(useLandscape);
      
      // Create print window
      const printWindow = window.open('', '_blank', 'width=1200,height=800');
      
      if (!printWindow) {
        console.error('Failed to open print window');
        return;
      }

      // Note: @page size cannot be set programmatically by browsers for security reasons
      // User must manually set orientation in print dialog
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>Inventory Adjustment Report - ${useLandscape ? 'Landscape' : 'Portrait'}</title>
          <style>
            /* Note: @page orientation cannot be set programmatically */
            @page { 
              margin: 8mm; 
            }
            body { 
              margin: 0; 
              padding: 8px; 
              font-family: Arial, sans-serif;
              font-size: ${useLandscape ? '8px' : '6px'};
              line-height: 1.1;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            table {
              page-break-inside: auto;
              break-inside: auto;
            }
            tr { 
              page-break-inside: avoid;
              break-inside: avoid;
            }
            thead { 
              display: table-header-group;
            }
            tfoot {
              display: table-footer-group;
            }
            @media print { 
              body { 
                margin: 0; 
                padding: 5px; 
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
              tr { 
                page-break-inside: avoid;
                break-inside: avoid;
              }
              thead { 
                display: table-header-group;
              }
              tfoot {
                display: table-footer-group;
              }
              .print-instructions {
                display: none;
              }
            }
          </style>
        </head>
        <body>
          ${iaReportHTML}
          <script>
            window.onload = function() {
              setTimeout(() => {
                window.print();
                window.close();
              }, 500);
            }
          </script>
        </body>
        </html>
      `);

      printWindow.document.close();
      console.log(`✅ IA Report Fast Print initiated successfully (${useLandscape ? 'Landscape' : 'Portrait'} mode)`);

    } catch (error) {
      console.error('❌ Error in IA Report fast print:', error);
    }
  };

  return (
    <div className="global-page-parent-container updated-global-page-parent-container" style={{ overflow: 'hidden' }}>
      <div className="justify-space-between list-create-head-bar">
        <h3>I A Report </h3>
        <div className="create-head-buttons-container">
          <div
            className="justify-center"
            style={{
              gap: "10px",
              width: "70%",
              justifyContent: "flex-end",
              paddingInline: "10px",
            }}
          >
            <Tooltip title="Print">
              <IconButton
                style={{
                  backgroundColor: "#4472C4",
                  color: "white",
                  borderRadius: "0",
                  height: "38px",
                  width: "37px",
                }}
                disabled={reportData.length === 0}
                onClick={handleFastPrint}
                title="Fast Print (Landscape)"
              >
                <PrintIcon />
              </IconButton>
            </Tooltip>
            
            <Tooltip title="Download Excel">
              <span>
                <IconButton
                  style={{
                    backgroundColor: "#ffd2d2",
                    color: "#002995",
                    borderRadius: "0",
                    height: "38px",
                    width: "37px",
                  }}
                  onClick={downloadExcel}
                  disabled={reportData.length === 0}
                >
                  <i className="bi bi-arrow-down-circle"></i>
                </IconButton>
              </span>
            </Tooltip>
            
            <Tooltip title="Search">
              <span>
                <TextField
                  size="small"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  InputProps={{
                    startAdornment: <SearchIcon style={{ marginRight: '8px', color: '#999' }} />
                  }}
                  sx={{
                    width: '250px',
                    '& .MuiOutlinedInput-root': {
                      height: '38px',
                      backgroundColor: 'white'
                    }
                  }}
                />
              </span>
            </Tooltip>
          </div>
        </div>
      </div>

      <div className="global-white-bg-container " style={{ display: "flex", alignItems: "center" }}>

        <div className="new-global-single-input auto-complete-new">
          <Autocomplete
            options={userRole === "admin" ? allBranchesList : allowedBranchList || []}
            getOptionLabel={(option) => option?.branchName}
            renderInput={(params) => (
              <TextField {...params} label="Branch" focused variant='outlined' />
            )}
            value={formValues?.branch}
            onChange={getBranchLocForm("branch")}
          />
          <p className="doc-validation-alert">{validationAlert?.branch}</p>
        </div>
        <div className="new-global-single-input">
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={wareHouseLocationList || []}
            getOptionLabel={(option) => option?.name}
            sx={{ width: 300 }}
            renderInput={(params) => (
              <TextField {...params} label="Location*" focused />
            )}
            value={formValues?.location}
            onChange={getBranchLocForm("location")}
            disabled={formValues?.isEdit}
          />
          <p className="doc-validation-alert">{validationAlert?.location}</p>
        </div>

        <div className="new-global-single-input" style={{ width: '21%' }}>
          <TextField
            id="outlined-basic"
            placeholder="From"
            onChange={handleInputChange("fromDate")}
            value={formValues?.fromDate}
            variant="outlined"
            type="date"
            focused
            label="From Date"
          />
          <p className="doc-validation-alert">{validationAlert?.fromDate}</p>
        </div>

        <div className="new-global-single-input" style={{ width: '21%' }}>
          <TextField
            id="outlined-basic"
            placeholder="From"
            onChange={handleInputChange("toDate")}
            value={formValues?.toDate}
            variant="outlined"
            type="date"
            focused
            label="To Date"
          />
          <p className="doc-validation-alert">{validationAlert?.toDate}</p>
        </div>

        <div className="new-global-single-input auto-complete-new">
          <Autocomplete
            multiple
            options={CategoryList || []}
            disableCloseOnSelect
            getOptionLabel={(option) => option?.categoryName || ""}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={<CheckBoxOutlineBlankIcon />}
                  checkedIcon={<CheckBoxIcon />}
                  checked={selected}
                />
                {option.categoryName}
              </li>
            )}
            renderInput={(params) => (
              <TextField {...params} label="Categories" placeholder="Select categories" focused />
            )}
            value={Array.isArray(formValues.selectedCategories) ? formValues.selectedCategories : []}
            onChange={(e, v) => handleCategoryChange(v || [], "selectedCategories")}
            filterSelectedOptions
            isOptionEqualToValue={(option, value) => option._id === value._id}
            disabled={formValues?.isEdit}
          />
        </div>

        <div style={{ marginTop: "0px" }} className="isFabric-class">
          <input type="checkbox"
            id="isRawMaterial"
            checked={formValues?.isRawMaterial}
            onChange={handleInputChange("isRawMaterial")}
          />
          <label htmlFor="isRawMaterial">Raw Materials</label>

        </div>

        <button
          onClick={saveBtnClick}
          className='btn btn-primary'
          disabled={isLoading}
          style={{ minWidth: '100px', position: 'relative' }}
        >
          {isLoading ? (
            <>
              <CircularProgress size={20} style={{ color: 'white', marginRight: '8px' }} />
              Loading...
            </>
          ) : (
            'Submit'
          )}
        </button>
      </div>
      {(reportData.length > 0 &&
        <div ref={printRef} className="global-report-table-container updated-table-container"
          style={{ height: "calc(100vh - 245px)", overflow: "auto", width: "100%" }}
        >
          <table style={{ paddingTop: "4px" }}>
            <thead>
              <tr style={{ backgroundColor: "#5B9BD5" }}>
                <th>NO</th>
                <th>Item Code</th>
                <th>Item Name</th>
                <th>Uom</th>
                <th>Conversion</th>
                <th>Rate</th>
                <th>Opening Stock</th>
                <th style={{ color: "green" }}>Purchase</th>
                <th style={{ color: "green" }}>Transfer In</th>
                <th style={{ color: "green" }}>Total Stock-In Qty</th>
                <th style={{ color: "green" }}>Total Stock-In Value</th>
                <th style={{ color: "red" }}>Purchase Return</th>
                <th style={{ color: "red" }}>Transfer Out</th>
                <th style={{ color: "red" }}>Raw Wastage Qty</th>
                <th style={{ color: "red" }}>SF Wastage</th>
                <th style={{ color: "red" }}>Finished Wastage Qty</th>
                <th style={{ color: "red" }}>Total Wastage Qty</th>
                <th style={{ color: "red" }}>Total Wastage Value</th>
                <th style={{ color: "red" }}>Total Out Qty</th>
                <th>Ideal Cons Qty</th>
                <th>Ideal Cons Value</th>
                <th>Book Closing Qty</th>
                <th>Book Closing Value</th>
                <th>Physical Closing Qty</th>
                <th>ActCons Qty</th>
                <th>ActCons Value</th>
                <th>Variance Qty</th>
                <th>Variance Value</th>
              </tr>
            </thead>
            <tbody>
              {
                isLoading ?
                  ([...Array(10)].map((r, i) => (
                    <tr key={i}>
                      <td colSpan={28}>
                        <Skeleton
                          variant="rectangular"
                          animation="wave"
                          width={"100%"}
                          height={40}
                        />
                      </td>
                    </tr>
                  ))
                  ) : reportData.length > 0 ?
                    reportData.map((group, groupIndex) => {
                      let itemCounter = 0;
                      return (
                        <>
                          {/* Group Header - light green band with subtle border */}
                          <tr
                            key={`group-${groupIndex}`}
                            style={{
                              backgroundColor: "#E6F4EA", // very light green
                              color: "#1B5E20",
                              fontWeight: 600,
                              borderTop: "1px solid #CFE8D5",
                              borderBottom: "1px solid #CFE8D5",
                            }}
                          >
                            <td
                              colSpan={28}
                              style={{
                                textAlignLast: "start",
                                paddingLeft: "10px",
                                paddingTop: "6px",
                                paddingBottom: "6px",
                                borderRadius: "6px",
                              }}
                            >
                              {group.itemGroup}
                            </td>
                          </tr>
                          
                          {/* Group Items */}
                          {group.items?.filter(item => {
                            if (!searchTerm) return true;
                            const search = searchTerm.toLowerCase();
                            return (
                              item.itemName?.toLowerCase().includes(search) ||
                              item.itemNo?.toLowerCase().includes(search) ||
                              item.uom?.toLowerCase().includes(search)
                            );
                          }).map((item, itemIndex) => {
                            itemCounter++;
                            return (
                              <tr key={`item-${groupIndex}-${itemIndex}`} style={{ cursor: "pointer" }}>
                                <td style={{ textAlignLast: "start", paddingLeft: "10px" }}>{itemCounter}</td>
                                <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{item.itemNo}</td>
                                <td style={{ textAlignLast: "start", paddingLeft: "10px" }}>{item.itemName}</td>
                                <td style={{ textAlignLast: "center" }}>{item.uom}</td>
                                <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{item.conversion}</td>
                                <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{Number(item.rate || 0).toFixed(decimalPosition)}</td>
                                <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{Number(item.openingStock || 0).toFixed(decimalPosition)}</td>
                                <td style={{ textAlignLast: "end", paddingRight: "10px", color: "green" }}>{Number(item.purchase || 0).toFixed(decimalPosition)}</td>
                                <td style={{ textAlignLast: "end", paddingRight: "10px", color: "green" }}>{Number(item.transferIn || 0).toFixed(decimalPosition)}</td>
                                <td style={{ textAlignLast: "end", paddingRight: "10px", color: "green" }}>{Number(item.totalStockInQty || 0).toFixed(decimalPosition)}</td>
                                <td style={{ textAlignLast: "end", paddingRight: "10px", color: "green" }}>{Number(item.totalStockInValue || 0).toFixed(decimalPosition)}</td>
                                <td style={{ textAlignLast: "end", paddingRight: "10px", color: "red" }}>{Number(item.purchaseReturn || 0).toFixed(decimalPosition)}</td>
                                <td style={{ textAlignLast: "end", paddingRight: "10px", color: "red" }}>{Number(item.transferOut || 0).toFixed(decimalPosition)}</td>
                                <td style={{ textAlignLast: "end", paddingRight: "10px", color: "red" }}>{Number(item.rawWastageQty || 0).toFixed(decimalPosition)}</td>
                                <td style={{ textAlignLast: "end", paddingRight: "10px", color: "red" }}>{Number(item.sfWastage || 0).toFixed(decimalPosition)}</td>
                                <td style={{ textAlignLast: "end", paddingRight: "10px", color: "red" }}>{Number(item.finishedWastageQty || 0).toFixed(decimalPosition)}</td>
                                <td style={{ textAlignLast: "end", paddingRight: "10px", color: "red" }}>{Number(item.totalWastageQty || 0).toFixed(decimalPosition)}</td>
                                <td style={{ textAlignLast: "end", paddingRight: "10px", color: "red" }}>{Number(item.totalWastageValue || 0).toFixed(decimalPosition)}</td>
                                <td style={{ textAlignLast: "end", paddingRight: "10px", color: "red" }}>{Number(item.totalOutQty || 0).toFixed(decimalPosition)}</td>
                                <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{Number(item.idealConsQty || 0).toFixed(decimalPosition)}</td>
                                <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{Number(item.idealConsValue || 0).toFixed(decimalPosition)}</td>
                                <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{Number(item.bookClosingQty || 0).toFixed(decimalPosition)}</td>
                                <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{Number(item.bookClosingValue || 0).toFixed(decimalPosition)}</td>
                                <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{Number(item.physicalClosingQty || 0).toFixed(decimalPosition)}</td>
                                <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{Number(item.actConsQty || 0).toFixed(decimalPosition)}</td>
                                <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{Number(item.actConsValue || 0).toFixed(decimalPosition)}</td>
                                <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{Number(item.varianceQty || 0).toFixed(decimalPosition)}</td>
                                <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{Number(item.varianceValue || 0).toFixed(decimalPosition)}</td>
                              </tr>
                            );
                          })}
                          
                          {/* Group Totals */}
                          <tr key={`total-${groupIndex}`} style={{ backgroundColor: "#BDD7EE", fontWeight: "bold" }}>
                            <td colSpan={9} style={{ textAlignLast: "end", paddingRight: "10px" }}>{group.itemGroup} Total</td>
                            {/* Total Stock-In Qty */}
                            <td style={{ textAlignLast: "end", paddingRight: "10px", color: "green" }}>{Number(group.groupTotals?.totalStockInQty || 0).toFixed(decimalPosition)}</td>
                            {/* Total Stock-In Value */}
                            <td style={{ textAlignLast: "end", paddingRight: "10px", color: "green" }}>{Number(group.groupTotals?.totalStockInValue || 0).toFixed(decimalPosition)}</td>
                            {/* Purchase Return, Transfer Out, Raw Wastage Qty, SF Wastage, Finished Wastage Qty */}
                            <td colSpan={5}></td>
                            {/* Total Wastage Qty */}
                            <td style={{ textAlignLast: "end", paddingRight: "10px", color: "red" }}>{Number(group.groupTotals?.totalWastageQty || 0).toFixed(decimalPosition)}</td>
                            {/* Total Wastage Value */}
                            <td style={{ textAlignLast: "end", paddingRight: "10px", color: "red" }}>{Number(group.groupTotals?.totalWastageValue || 0).toFixed(decimalPosition)}</td>
                            {/* Total Out Qty */}
                            <td style={{ textAlignLast: "end", paddingRight: "10px", color: "red" }}>{Number(group.groupTotals?.totalOutQty || 0).toFixed(decimalPosition)}</td>
                            {/* Ideal Cons Qty, Ideal Cons Value */}
                            <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{Number(group.groupTotals?.idealConsQty || 0).toFixed(decimalPosition)}</td>
                            <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{Number(group.groupTotals?.idealConsValue || 0).toFixed(decimalPosition)}</td>
                            {/* Book Closing Qty, Book Closing Value */}
                            <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{Number(group.groupTotals?.bookClosingQty || 0).toFixed(decimalPosition)}</td>
                            <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{Number(group.groupTotals?.bookClosingValue || 0).toFixed(decimalPosition)}</td>
                            {/* Physical Closing Qty, ActCons Qty, ActCons Value */}
                            <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{Number(group.groupTotals?.physicalClosingQty || 0).toFixed(decimalPosition)}</td>
                            <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{Number(group.groupTotals?.actConsQty || 0).toFixed(decimalPosition)}</td>
                            <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{Number(group.groupTotals?.actConsValue || 0).toFixed(decimalPosition)}</td>
                            {/* Variance Qty, Variance Value */}
                            <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{Number(group.groupTotals?.varianceQty || 0).toFixed(decimalPosition)}</td>
                            <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{Number(group.groupTotals?.varianceValue || 0).toFixed(decimalPosition)}</td>
                          </tr>
                        </>
                      );
                    })
                    :
                    <tr>
                      <td colSpan={28}>No Records - Please select filters and click Submit</td>
                    </tr>
              }
            </tbody>
            {
              !isLoading && reportData.length > 0 &&
              <tfoot>
                <tr style={{ backgroundColor: "#4472C4", color: "white", fontWeight: "bold" }}>
                  <th colSpan={9} style={{ textAlignLast: "end", paddingRight: "10px" }}>GRAND TOTAL</th>
                  {/* Total Stock-In Qty */}
                  <th style={{ textAlignLast: "end", paddingRight: "10px", backgroundColor: "#70AD47" }}>{formatNumber(grandTotals?.totalStockInQty)}</th>
                  {/* Total Stock-In Value */}
                  <th style={{ textAlignLast: "end", paddingRight: "10px", backgroundColor: "#70AD47" }}>{formatNumber(grandTotals?.totalStockInValue)}</th>
                  {/* Purchase Return, Transfer Out, Raw Wastage Qty, SF Wastage, Finished Wastage Qty */}
                  <th colSpan={5}></th>
                  {/* Total Wastage Qty */}
                  <th style={{ textAlignLast: "end", paddingRight: "10px", backgroundColor: "#C00000" }}>{formatNumber(grandTotals?.totalWastageQty)}</th>
                  {/* Total Wastage Value */}
                  <th style={{ textAlignLast: "end", paddingRight: "10px", backgroundColor: "#C00000" }}>{formatNumber(grandTotals?.totalWastageValue)}</th>
                  {/* Total Out Qty */}
                  <th style={{ textAlignLast: "end", paddingRight: "10px", backgroundColor: "#C00000" }}>{formatNumber(grandTotals?.totalOutQty)}</th>
                  {/* Ideal Cons Qty, Ideal Cons Value */}
                  <th style={{ textAlignLast: "end", paddingRight: "10px", backgroundColor: "#FFC000" }}>{formatNumber(grandTotals?.idealConsQty)}</th>
                  <th style={{ textAlignLast: "end", paddingRight: "10px", backgroundColor: "#FFC000" }}>{formatNumber(grandTotals?.idealConsValue)}</th>
                  {/* Book Closing Qty, Book Closing Value */}
                  <th style={{ textAlignLast: "end", paddingRight: "10px", backgroundColor: "#70AD47" }}>{formatNumber(grandTotals?.bookClosingQty)}</th>
                  <th style={{ textAlignLast: "end", paddingRight: "10px", backgroundColor: "#70AD47" }}>{formatNumber(grandTotals?.bookClosingValue)}</th>
                  {/* Physical Closing Qty, ActCons Qty, ActCons Value */}
                  <th style={{ textAlignLast: "end", paddingRight: "10px", backgroundColor: "#FFC000" }}>{formatNumber(grandTotals?.physicalClosingQty)}</th>
                  <th style={{ textAlignLast: "end", paddingRight: "10px", backgroundColor: "#FFC000" }}>{formatNumber(grandTotals?.actConsQty)}</th>
                  <th style={{ textAlignLast: "end", paddingRight: "10px", backgroundColor: "#FFC000" }}>{formatNumber(grandTotals?.actConsValue)}</th>
                  {/* Variance Qty, Variance Value */}
                  <th style={{ textAlignLast: "end", paddingRight: "10px", backgroundColor: "#C00000" }}>{formatNumber(grandTotals?.varianceQty)}</th>
                  <th style={{ textAlignLast: "end", paddingRight: "10px", backgroundColor: "#C00000" }}>{formatNumber(grandTotals?.varianceValue)}</th>
                </tr>
              </tfoot>
            }
          </table>
        </div>
      )}

    </div>
  );
};

export default IaReport;
